function extractBeforeSlash(inputString) {
    // Find the index of the first '/'
    var index = inputString.indexOf('/');
    // If '/' is found, extract the substring before it; otherwise, return the original string
    return index !== -1 ? inputString.substring(0, index) : inputString;
}

var MemberServices = {

    /**
     * Get all schedules for given equipment between times provided
     * @param {string}      barcode   requested start time
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    getMemberByBarcodePlus: function (barcode, onSuccess, onFail) {
        $.ajax({
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8"
            },
            retryCall: false,
            timeout:20000,
            data: {
                "requestingClub": common.configData.clubCode,
                "barcode": extractBeforeSlash(barcode)
            },
            url: config.MEMBER_SERVICE + "/Member/BarcodePlus",
            success: function (data) {
                if(!data){
                  onFail(null, null, 'There was a problem connecting to the member service. Please contact your system administrator.');
                }
                else {
                    onSuccess(data);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                onFail(jqXHR, textStatus, errorThrown);
            }
        });
    },
    /**
     * Get all schedules for given equipment between times provided
     * @param {string}      barcode   requested start time
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    getMemberByBarcode: function (barcode, onSuccess, onFail) {
        $.ajax({
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8"
            },
            retryCall: false,
            timeout:20000,
            data: {
                "requestingClub": common.configData.clubCode,
                "barcode": extractBeforeSlash(barcode)
            },
            url: config.MEMBER_SERVICE + "/Member/Barcode",
            success: function (data) {
              if(!data){
                onFail(null, null, 'There was a problem connecting to the member service. Please contact your system administrator.');
              }
              else {
                onSuccess(data);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var err;
                if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message){
                    // err = jqXHR.responseJSON.message;
                    err = 'jqXHR.responseJSON.message 66';
                }
                else {
                    err = 'There was a problem accessing the member service, please try your request again or contact a system administrator.';
                }
                onFail(err);
            }
        });
    },

    /**
     * Get all schedules for given equipment between times provided
     * @param {string}      guid        requested start time
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    getMemberByGuid: function (guid, onSuccess, onFail) {
        $.ajax({
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8"
            },
            retryCall: false,
            timeout:20000,
            data: {
                "requestingClub": common.configData.clubCode,
                "memberGuid": guid
            },
            url: config.MEMBER_SERVICE + "/Member/Id",
            success: function (data) {
              if(!data){
                onFail(null, null, 'There was a problem connecting to the member service. Please contact your system administrator.');
              }
              else {
                onSuccess(data);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var err;
                if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message){
                    // err = jqXHR.responseJSON.message;
                    err = 'jqXHR.responseJSON.message 107';
                }
                else {
                    err = 'There was a problem accessing the member service, please try your request again or contact a system administrator.';
                }
                common.showError(null, null, err);
            }
        });
    },

    /**
     * Get all schedules for given equipment between times provided
     * @param {string}      clubId      member home club identification number
     * @param {string}      memberGuid  member guid
     * @param {function}    done        callback
     */
    getMemberPhoto: function (memberGuid, clubId, done) {
        $.ajax({
            method: "GET",
            headers: {
                Accept: "text/plain; charset=utf-8"
            },
            timeout:5000,
            retryCall: false,
            data: {
                "clubId": clubId,
                "memberGuid" : memberGuid
            },
            url: config.MEMBER_SERVICE + "/Member/Photo",
            success: function (data) {
                done(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                done();
            }
        });
    },

    /**
     * Get all schedules for given equipment between times provided
     * @param {string}      params      parameter object
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    getMemberSearch: function (params, onSuccess, onFail) {
        var queryData = {
                "requestingClub": common.configData.clubCode,
                "clubId": params.clubId,
                "firstName": params.firstName,
                "lastName": params.lastName,
                "barcode": extractBeforeSlash(params.barcode),
                "email": params.email,
                "phone": params.phone,
                "pageCount": params.pageCount,
                "page": params.page
        };
        if(params.countryCode){
            queryData["countryCode"] = params.countryCode;
        }
        $.ajax({
            method: "GET",
            retryCall: false,
            timeout:60000,
            data: queryData,
            url: config.MEMBER_SERVICE + "/memberSearch",
            beforeSend: function (request, settings) {
                settings.url = settings.url.replace(/\+/g, "%20");
            },
            success: function (data) {
                onSuccess(data, params);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var err;
                if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message){
                    err = jqXHR.responseJSON.message;
                    err = pfFetchTranslation('search.noResults');
                }
                onFail(err);
            }
        });
    },

    /**
     * Get all schedules for given equipment between times provided
     * @param {string}      memberGuid  member guid
     * @param {string}      waiverId    waiver guid
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    getMemberWaivers: function (memberGuid, waiverId, onSuccess, onFail) {
        $.ajax({
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8"
            },
            retryCall: false,
            timeout:20000,
            data: {
                "memberId": memberGuid,
                "waiverId": waiverId
            },
            url: config.MEMBER_SERVICE + "/memberWaivers",
            success: function (data) {
              onSuccess(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if(onFail){
                    onFail(jqXHR, textStatus, errorThrown);
                }
                else {
                    console.error(jqXHR, textStatus, errorThrown)
                }
            }
        });
    },

    getMemberTanning:function(memberguid, amenityCategoryGuid, onSuccess, onFail){
        $.ajax({
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8"
            },
            timeout:20000,
            data: {
                "memberGuid": memberGuid,
                "amenityCategoryGuid": amenityCategoryGuid
            },
            url: config.MEMBER_SERVICE + "/tanning",
            success: function (res) {
                onSuccess(res);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if(onFail){
                    onFail(jqXHR, textStatus, errorThrown);
                }
            }
        });
    },

    /**
     * Add a guest member for scheduling
     * @param {string}      memberObj   member object
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    addGuest: function (memberObj, onSuccess, onFail) {
        $.ajax({
            method: "PUT",
            data: JSON.stringify(memberObj),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            url: config.MEMBER_SERVICE + "/member/guest",
            success: function (res) {
                onSuccess(res);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if(onFail){
                    onFail(jqXHR, textStatus, errorThrown);
                }
                else {
                    console.error(jqXHR, textStatus, errorThrown)
                }
            }
        });
    },
    /**
     * Get last 31 schedules for given category for given member
     * @param {string}      memberGuid     requested memberGuid
     * @param {string}      categoryGuid   requested categoryGuid
     * @param {function}    onSuccess      xhr success
     * @param {function}    onFail         xhr fail
     */
    getCategoryScheduleHistory : function (memberGuid, categoryGuid, onSuccess, onFail) {
      $.ajax({
        method: "GET",
        headers: {
          Accept: "application/json; charset=utf-8"
        },
        timeout:20000,
        data: {
          "memberGuid": memberGuid,
          "categoryGuid": categoryGuid
        },
        url: config.MEMBER_SERVICE + "/Member/AmenityInfo",
        success: function (res) {
          onSuccess(res);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if(onFail){
            onFail(jqXHR, textStatus, errorThrown);
          }
          else {
            console.error(jqXHR, textStatus, errorThrown)
          }
        }
      });
    },
    getMemberScanDoc: function (memberGuid, docTypeName, onSuccess, onFail) {
        var temp_MEMBER_SERVICE = 'https://pfmembersvc-pfmembersvc-dev.azurewebsites.net';
        $.ajax({
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8"
            },
            retryCall: false,
            timeout:20000,
            data: {
                "clubId": common.configData.clubCode,
                "memberGuid": memberGuid,
                "docTypeName": docTypeName
            },
            url: temp_MEMBER_SERVICE + "/Member/Photo",
            success: function (data) {
              if(!data){
                onFail(null, null, 'There was a problem connecting to the member service. Please contact your system administrator.');
              }
              else {
                onSuccess(data);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var err;
                if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message){
                    err = jqXHR.responseJSON.message;
                }
                else {
                    err = 'There was a problem accessing the member service, please try your request again or contact a system administrator.';
                }
                onFail(err);
            }
        });
    },
    /**
     *
     * @param {string}      MemberGuid  member guid
     * @param {string}      waiverid    waiver guid
     * @param {string}      title       waiver title
     * @param {string}      content     waiver content
     * @param {function}    onSuccess   xhr success
     * @param {function}    onFail      xhr fail
     */
    updateMemberWaiver: function (MemberGuid, waiverid, title, content, onSuccess, onFail) {
        var waiverData;
        var lang = langLookup();
        common.setLoader(pfFetchTranslation('siteLoad.signingWaiver'));

        waiverData = {
            'SignDate': moment().format(common.dateFormat),
            'Title': title,
            'WaiverId': waiverid,
            'Content': content,
            "language": lang
        };

        $.ajax({
            method: 'POST',
            data: JSON.stringify(waiverData),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: config.MEMBER_SERVICE + '/Members/' + MemberGuid + '/Waivers',
            success: function (data) {
                onSuccess(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                onFail(jqXHR, textStatus, errorThrown);
            }
        });
    }

};

if (typeof module === 'object' && module.exports) {
    module.exports = MemberServices;
}
